import {SystemProcessExecution, SystemProcessExecutionEntity} from "../../../model/system-process-execution";
import {
  SystemProcessExecutionArtifact,
  SystemProcessExecutionArtifactEntity
} from "../../../model/system-process-execution-artifact";
import {
  SystemProcessExecutionIssue,
  SystemProcessExecutionIssueEntity
} from "../../../model/system-process-execution-issue";
import {
  SystemProcessExecutionMetric,
  SystemProcessExecutionMetricEntity
} from "../../../model/system-process-execution-metric";
import {makeEntitySelectors} from "../base-entity-store";
import {
  SystemProcessExecutionMissingMapping,
  SystemProcessExecutionMissingMappingEntity
} from "../../../model/system-process-execution-missing-mapping";

export interface SystemProcessExecutionSelectorProps {

}

const systemProcessExecutionSelectors = makeEntitySelectors<
  SystemProcessExecution,
  SystemProcessExecutionEntity,
  SystemProcessExecutionSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => SystemProcessExecutionEntity.from(value),
});

export const systemProcessExecutionsSelector =
  (props?: SystemProcessExecutionSelectorProps) =>
    systemProcessExecutionSelectors.listSelector(props);

export const systemProcessExecutionSelector =
  () => systemProcessExecutionSelectors.singleSelector();

// =================================
//
// System Process Execution Artifacts
//
// ================================

export interface SystemProcessExecutionArtifactSelectorProps {

}

const systemProcessExecutionArtifactSelectors = makeEntitySelectors<
  SystemProcessExecutionArtifact,
  SystemProcessExecutionArtifactEntity,
  SystemProcessExecutionArtifactSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => SystemProcessExecutionArtifactEntity.from(value),
});

export const systemProcessExecutionArtifactsSelector =
  (props?: SystemProcessExecutionArtifactSelectorProps) =>
    systemProcessExecutionArtifactSelectors.listSelector(props);

export const systemProcessExecutionArtifactSelector =
  () => systemProcessExecutionArtifactSelectors.singleSelector();

// =================================
//
// System Process Execution Issues
//
// ================================

export interface SystemProcessExecutionIssueSelectorProps {

}

const systemProcessExecutionIssueSelectors = makeEntitySelectors<
  SystemProcessExecutionIssue,
  SystemProcessExecutionIssueEntity,
  SystemProcessExecutionIssueSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => SystemProcessExecutionIssueEntity.from(value),
});

export const systemProcessExecutionIssuesSelector =
  (props?: SystemProcessExecutionIssueSelectorProps) =>
    systemProcessExecutionIssueSelectors.listSelector(props);

export const systemProcessExecutionIssueSelector =
  () => systemProcessExecutionIssueSelectors.singleSelector();

// =================================
//
// System Process Execution Metrics
//
// ================================

export interface SystemProcessExecutionMetricSelectorProps {

}

const systemProcessExecutionMetricSelectors = makeEntitySelectors<
  SystemProcessExecutionMetric,
  SystemProcessExecutionMetricEntity,
  SystemProcessExecutionMetricSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => SystemProcessExecutionMetricEntity.from(value),
});

export const systemProcessExecutionMetricsSelector =
  (props?: SystemProcessExecutionMetricSelectorProps) =>
    systemProcessExecutionMetricSelectors.listSelector(props);

export const systemProcessExecutionMetricSelector =
  () => systemProcessExecutionMetricSelectors.singleSelector();

// =================================
//
// System Process Execution Missing Mappings
//
// ================================

export interface SystemProcessExecutionMissingMappingSelectorProps {

}

const systemProcessExecutionMissingMappingSelectors = makeEntitySelectors<
  SystemProcessExecutionMissingMapping,
  SystemProcessExecutionMissingMappingEntity,
  SystemProcessExecutionMissingMappingSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => SystemProcessExecutionMissingMappingEntity.from(value),
});

export const systemProcessExecutionMissingMappingsSelector =
  (props?: SystemProcessExecutionMissingMappingSelectorProps) =>
    systemProcessExecutionMissingMappingSelectors.listSelector(props);

export const systemProcessExecutionMissingMappingSelector =
  () => systemProcessExecutionMissingMappingSelectors.singleSelector();
